import { useAppDispatch } from './app.hooks';
import { setTheme } from '../store/app.slice';

export type ThemeVariable = 'toka' | 'tokaLight' | 'sber' | 'gazprom' | 'spartak' | 'ms' | 'main';
export const themColors = {
  toka: {
    text: 'rgba(24, 24, 24, 1.00)',
    color: '#33aba0',
  },
  tokaLight: {
    text: 'rgba(24, 24, 24, 1.00)',
    color: '#b0deda',
  },
  sber: {
    text: '#354235',
    color: '#4ca45c',
  },
  gazprom: {
    text: '#001821',
    color: '#0078c2',
  },
  spartak: {
    text: '#3d0101',
    color: '#CD0000',
  },
  ms: {
    text: '#404147',
    color: '#F25530',
  },
  main: {
    text: '#0D101C',
    color: '#C32B46',
  },
  
};

interface UseChangeTheme {
  setCssVariable: (name: string, value: string) => void;
  chaneTheme: (themeVariable: ThemeVariable) => void;
}

export const useChangeTheme = (): UseChangeTheme => {
  const dispatch = useAppDispatch();
  const root = document.documentElement;
  const setCssVariable = (name: string, value: string) => {
    root.style.setProperty(name, value);
  };

  const chaneTheme = (themeVariable: ThemeVariable) => {
    switch (themeVariable) {
      case 'toka':
        root.style.setProperty('--text-color', themColors.toka.text);
        root.style.setProperty('--main-color', themColors.toka.color);
        root.style.setProperty('--border-color', themColors.toka.color);
        break;
      case 'tokaLight':
        root.style.setProperty('--text-color', themColors.tokaLight.text);
        root.style.setProperty('--main-color', themColors.tokaLight.color);
        root.style.setProperty('--border-color', themColors.tokaLight.color);
        break;
      case 'sber':
        root.style.setProperty('--text-color', themColors.sber.text);
        root.style.setProperty('--main-color', themColors.sber.color);
        root.style.setProperty('--border-color', themColors.sber.color);
        break;
      case 'spartak':
        root.style.setProperty('--text-color', themColors.spartak.text);
        root.style.setProperty('--main-color', themColors.spartak.color);
        root.style.setProperty('--border-color', themColors.spartak.color);
        break;
      case 'gazprom':
        root.style.setProperty('--text-color', themColors.gazprom.text);
        root.style.setProperty('--main-color', themColors.gazprom.color);
        root.style.setProperty('--border-color', themColors.gazprom.color);
        break;
      case 'ms':
        root.style.setProperty('--text-color', themColors.ms.text);
        root.style.setProperty('--main-color', themColors.ms.color);
        root.style.setProperty('--border-color', themColors.ms.color);
        break;
      default:
        root.style.setProperty('--text-color', themColors.main.text);
        root.style.setProperty('--main-color', themColors.main.color);
        root.style.setProperty('--border-color', themColors.main.color);
        break;
    }
    dispatch(setTheme(themeVariable));
  };

  return { setCssVariable, chaneTheme };
};
